import config from "../config";

import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";

import { initiateMainLoop } from "./actions/controllers/main";

import reducers from "./reducers";
import sagas from "./sagas";
import websockets from "./sockets";

// Set constants.
export const BASE_URL_API_PROD = "https://api.vanzadelhoff.nl";
export const BASE_URL_API_DEV = "https://vanzadelhoff.nl/tstomg/api";
export const BASE_URL_CONTENT = "https://api.vanzadelhoff.nl/content";

// Return constants.
export const BASE_URL_API = config.live ? BASE_URL_API_PROD : BASE_URL_API_DEV;
export const BASE_URL_CACHE = BASE_URL_API + "/cache";

// Create middlewares.
const sagaMiddleware = createSagaMiddleware();
const websocketSagaMiddleware = createSagaMiddleware();

// Link console logger.
const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Extension options
      })
    : compose;

// Link middlewares.
const enhancers = composeEnhancers(
  applyMiddleware(sagaMiddleware, websocketSagaMiddleware)
);

// Create store.
export const store = createStore(reducers, enhancers);

// Attach sagas.
sagaMiddleware.run(sagas);
websocketSagaMiddleware.run(websockets);

// Attach controllers.
store.dispatch(initiateMainLoop());



// WEBPACK FOOTER //
// ./src/redux/store.js